import React, { useEffect } from 'react';
import { Row, Col, Form } from 'antd';
import size from 'lodash/size';
import { omit , isNil } from 'lodash';

import { ReactComponent as Bin } from 'assets/icons/bin.svg';
import { FormField } from 'components';
import { carrierUsersFields } from './field';
import { useSelector, useDispatch } from 'react-redux';
import { setValidity, updateFormField } from 'store/forms/actions';
import { validateAFM, validateUserAFM } from 'utils';

const CarrierUsers = ({
  update,
  removeUser,
  index,
  carrierUsers,
  options,
  disabled,
  disableEmail,
}) => {
  const carrier = useSelector(state => state.forms.carrier)
  const handleChange = ({ key, newValue, type }) => {
    let value;
    if (type === 'select'  || type === 'numberWithDecimals' ) {
      value = newValue;
    } else if (type === 'text' || type === 'textarea' || type === 'radio') {
      value = key === "userEmail" ? newValue.target.value.toLowerCase() : newValue.target.value;
    }
    update({ key, value, index });
  };

  const dispatch = useDispatch();


  return (
    <div className="shareHolderRow">
      <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }} key={index}>
        {carrierUsersFields(carrierUsers).map((field, i) => {
          return (
            <Col key={i} span={field.span} className="pt-1 pb-1">
              <Form.Item
                name={['carrierUsers', index, field.name]}
                validateFirst={true}
                rules={field.rules}
              >
                <FormField
                  value={carrierUsers[index] && carrierUsers[index][field.name]}
                  {...omit(field, ['span', 'rules'])}
                  disabled={field.name === 'userEmail' ? (disabled || index === 0 || disableEmail) : (disabled || index === 0)}
                  key={index + '_' + field.name + '_' + i}
                  onChange={event =>
                    handleChange({
                      key: field.name,
                      newValue: event,
                      type: field.type,
                    })
                  }
                />
              </Form.Item>
            </Col>
          );
        })}

        {(!disabled && index > 0 ) &&  (
          <Col className=" delete-icon pt-1 pb-1">
            <Bin
              onClick={() => removeUser(index)}
            />
          </Col>
        )}
        <Col span={10}></Col>
      </Row>
    </div>
  );
};

export default CarrierUsers;
